/**
 * @file コンポーネント：検索結果ページ検索条件フィルター DOM管理
 */

// ライブラリ読み込み
import React from "react";

// スタイル読み込み
import {
    StyledList,
    StyledListFilter,
    StyledListFilterLabel,
    StyledListFilterValue,
    StyledListItem,
} from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    // ReactDOM
    return (
        <StyledList>
            {props.list.map((item, index) => (
                <StyledListItem key={"item-" + index}>
                    <StyledListFilter
                        data-on-color={props.onColor}
                        href={item.url}
                        title={localized["Label.ClearThisFilter"]}
                    >
                        <StyledListFilterLabel>
                            {item.label}
                        </StyledListFilterLabel>
                        <StyledListFilterValue
                            dangerouslySetInnerHTML={{ __html: item.value }}
                            data-type={item.type}
                        />
                    </StyledListFilter>
                </StyledListItem>
            ))}
        </StyledList>
    );
};
